import { Module } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { IRoot, IRawProducts } from '@/interfaces';
import getInitialState from './initialState';

const state = getInitialState();
const namespaced: boolean = true;

export const products: Module<IRawProducts, IRoot> = {
	namespaced,
	state,
	actions,
	getters,
	mutations,
};

export default products;
